export default __webpack_public_path__ + "static/media/clock.455a7309.svg";